import { PortletConfig } from '../../../../shared/components/portlet/portlet/portlet.component';

export const TEMPLATE_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  BUTTON_COUNT: 5,

  // Portlet configuration
  PORTLET_CONFIG: {
    title: 'Template',
    subtitle: 'Manage all templates',
    icon: 'bi bi-people',
    showHeader: true,
    noPadding: true,
    offsetHeight: 100,
    minHeight: 400,
    collapsible: false,
  } as PortletConfig,

  // Grid messages
  MESSAGES: {
    LOAD_ERROR: 'Failed to load doctors',
    DELETE_SUCCESS: 'Doctor deleted successfully',
    DELETE_ERROR: 'Failed to delete doctor',
    ADD_SUCCESS: 'Doctor added successfully',
    UPDATE_SUCCESS: 'Doctor updated successfully',
  },
};
